import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { getFontColorStyle } from '../../helpers';
import type { FontColorType } from '../../helpers';
import { getFontFamilyStyle, getTextAlignStyle } from '../text/text-style-helpers';
import type { TextAlignment } from '../text/text-style-helpers';

export type HeadingStylesProps = {
  color: FontColorType;
  level: 1 | 2 | 3;
  textAlign: TextAlignment;
};

const style = ({ color, level, textAlign }: HeadingStylesProps) =>
  css`
    ${getFontColorStyle(color, theme)}
    ${getFontFamilyStyle(theme)}
    ${getTextAlignStyle(textAlign)}
    font-size: ${theme.font.size[`h${level}`] ?? theme.font.size.h1};
    font-weight: ${theme.font.weight.bold};
    line-height: ${theme.font.lineHeight};
  `;

export const HeadingStyles = {
  heading: (props: HeadingStylesProps) => style(props),
};
